import type { Snapshot } from "@app/protocol";
import type { AnyView } from "../variants/types";

/** What changed between two snapshots that is worth a sound (review 0013). */
export type TableCue = "card" | "hand-end" | "match-end";

const cardsHeld = (view: AnyView): number => view.handCounts.reduce((sum, n) => sum + n, 0);

/**
 * Only live changes: the first snapshot of a table (a reload, a late join, another
 * table) says nothing. A card left someone's hand; a hand or the match just ended. Pure.
 */
export function tableCues(prev: Snapshot | null, next: Snapshot): TableCue[] {
  if (prev === null || prev.table.id !== next.table.id) return [];
  const was = prev.view as AnyView | null;
  const is = next.view as AnyView | null;
  const cues: TableCue[] = [];
  if (was !== null && is !== null && cardsHeld(is) < cardsHeld(was)) cues.push("card");
  if (was !== null && is !== null && was.phase !== "hand-end" && is.phase === "hand-end")
    cues.push("hand-end");
  if (prev.table.status !== "finished" && next.table.status === "finished") cues.push("match-end");
  return cues;
}
